import { styled } from "@mui/material";
import bg from 'assets/bg-grid.png'

export const Container = styled('div')(({ theme }) => ({
  backgroundImage: `url(${bg})`,
  height: "100%",
  position: "relative",

  ".svg": {
    position: "absolute",
    left: 0,
    top: 0,
    pointerEvents: "none",

    "path.active": {
      stroke: theme.palette.primary.main
    }
  },
  "&.create-chain": {
    ".block:hover": {
      borderColor: theme.palette.primary.dark
    }
  }
}))